import moment from "moment";
import Repo from "../../Repository/Repo";
import { syncTransaction } from "./transactionSlice";
import { Toast } from "../components/Toast";

export const submitTransaction = async ({ record, dispatch }) => {
  try {
    let { data } = await Repo.datebook({
      request: {
        method: "saveDateBook",
        data: {
          dateBook: {
            nameNumber: record.nameNumber,
            credit: record.credit,
            debit: record.debit,
            company_code: localStorage.getItem("companyCode"),
            date: moment(record.date).format("DD-MM-YYYY"),
            category: record.category,
            created_at: record.created_at,
          },
        },
      },
    });

    if (data.response.data.datebook) {
      dispatch(syncTransaction(record.created_at));
    }
  } catch (err) {
    console.log("err:", err);
    Toast("error", "Error");
  }

  //   if (record.broughtForward) {
  //     let datebook = balance;
  //     datebook.balance = record.broughtForward;
  //     if (record.forwardType == "subtract") {
  //       let { data } = await Repo.datebook({
  //         request: {
  //           method: "editDateBookBalance",
  //           data: {
  //             dateBook: datebook,
  //           },
  //         },
  //       });
  //       console.log("data:", data);
  //     } else {
  //       let { data } = await Repo.datebook({
  //         request: {
  //           method: "updateDateBookBalance",
  //           data: {
  //             dateBook: datebook,
  //           },
  //         },
  //       });
  //       console.log("data:", data);
  //     }
  //   }
};
